import { render, staticRenderFns } from "./api-create-integration-link-form.vue?vue&type=template&id=d85862b6&"
import script from "./api-create-integration-link-form.vue?vue&type=script&lang=js&"
export * from "./api-create-integration-link-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports